<template>
    <div>
        <div class="panel">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-user"></i>
                    <span>{{$t('dashboard.profile.title')}}</span>
                </h2>
            </div>
            <div class="panel__body">
                <table class="table--data">
                    <tbody>
                        <tr v-if="client.initials">
                            <th>{{$t('forms.client.initials')}} </th>
                            <td>{{client.initials}}</td>
                        </tr>
                        <tr v-if="client.name">
                            <th>{{$t('forms.client.name')}}</th>
                            <td>{{client.name}}</td>
                        </tr>
                        <tr v-if="client.gender">
                            <th>{{$t('forms.client.gender')}}</th>
                            <td>{{client.gender == 'm' ? $t('forms.client.male') : $t('forms.client.female') }}</td>
                        </tr>
                        <tr v-if="client.date_of_birth">
                            <th>{{$t('forms.client.date_of_birth')}}</th>
                            <td>{{cleanDate(client.date_of_birth)}}</td>
                        </tr>
                        <tr v-if="client.place_of_birth">
                            <th>{{$t('forms.client.place_of_birth')}}</th>
                            <td>{{client.place_of_birth}}</td>
                        </tr>
                        <tr v-if="client.email">
                            <th>{{$t('forms.client.email')}}</th>
                            <td>{{client.email}}</td>
                        </tr>
                        <tr v-if="client.phone_number">
                            <th>{{$t('forms.client.phone_number')}}</th>
                            <td>{{client.phone_number}}</td>
                        </tr>
                        <tr v-if="client.mobile_number">
                            <th>{{$t('forms.client.mobile_number')}}</th>
                            <td>{{client.mobile_number}}</td>
                        </tr>
                        <tr v-if="client.address">
                            <th>{{$t('dashboard.profile.address')}}</th>
                            <td>
                                {{client.address}}
                                {{client.address_number}}
                                {{client.address_number_suffix}}<br>
                                {{client.postal_code}}
                                {{client.city_name}}
                            </td>
                        </tr>
                        <tr v-if="client.quote_text">
                            <th>{{$t('dashboard.profile.quote_text')}}</th>
                            <td>{{client.quote_text}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    import Client from '@/models/Client';

    @Component()
    export default class ProfilePanel extends Vue {
        name = 'profile-panel';
        client = new Client();

        created() {
            this.client.fill(this.$store.state.profile.profile);
        }

        cleanDate(date) {
            const d = new Date(date);
            if (typeof d.toLocaleDateString === 'function') return d.toLocaleDateString();
            return d.toLocaleString();
        }
    }

    Vue.component('profile-panel', ProfilePanel);
</script>



// WEBPACK FOOTER //
// src/components/panels/profile/ProfilePanel.vue